/**
 * The selectable date-of-birth range, shared by every screen that asks for one
 * (onboarding's BasicInfo and the profile editor) so both wheels offer the same
 * years.
 */
import { PROFILE_INFO_LIMITS } from '@wlb/shared/api/onboarding/onboardingErrors';

/** How far back the picker reaches from the youngest selectable year. */
const SELECTABLE_YEARS = 100;

/**
 * The range stops at the youngest accepted age, because a later year could only
 * produce the "at least {age} years old" error.
 */
export const MAX_DOB_YEAR = new Date().getFullYear() - PROFILE_INFO_LIMITS.MIN_AGE_YEARS;
export const MIN_DOB_YEAR = MAX_DOB_YEAR - SELECTABLE_YEARS;
